export const projectsPerPage = 4;